import React from 'react';

export const SvgIcon = ({
  icon: IconComp,
  width,
  height,
  color,
  style,
  className,
}: {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  width: number;
  height: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  return (
    <IconComp
      width={width}
      height={height}
      className={className}
      style={{
        width,
        height,
        color,
        ...style,
      }}
    />
  );
};
